import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  checkbox: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    content: "' '",
  },
  clickable: {
    cursor: 'pointer',
  },
});
